import notificationSettingsApi from '../api/notificationSettingsApi';
import EmailNotificationSettings from '../models/emailNotificationSettings';
import PushNotificationSettings from '../models/pushNotificationSettings';

class notificationSettingsService {
  /**
   *
   * @param params:
   *
   // Messages query MessageReceivePermission No
   // Views query MessageReceivePermission No
   // Likes query MessageReceivePermission No
   // Favourites query MessageReceivePermission No
   // Matches query bool No
   // RHPTeamMessages query bool No
   * @returns {Promise<{data: PushNotificationSettings, success: *, message: *}>}
   */
  patchNotificationSettings(params) {
    return notificationSettingsApi.patchNotificationSettings(params).then(res => {
      try {
        return {
          success: res.success,
          data: PushNotificationSettings.mappingObject(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: notificationSettingsService/patchActionNotification:', res);
        throw new Error('failed');
      }
    });
  }

  /**
   *
   * @param params:
   *
   // MatchReport query bool No
   // DateFinder query bool No
   // Events query bool No
   // Offers query bool No
   // RHPTeamMessages query bool No
   * @returns {Promise<{data: EmailNotificationSettings, success: *, message: *}>}
   */
  patchEmailSettings(params) {
    return notificationSettingsApi.patchEmailSettings(params).then(res => {
      try {
        return {
          success: res.success,
          data: EmailNotificationSettings.mappingObject(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: notificationSettingsService/patchActionNotification:', res);
        throw new Error('failed');
      }
    });
  }
}

export default new notificationSettingsService();
